// extracted by mini-css-extract-plugin
export var checkoutRateBadge = "_sq-0";
export var checkoutRateBadgeLink = "_sq-1";